import {
   GET_CATEGORIES,
   CHANGE_VALUES_FORM,
   SELECTED_ITEMS_CONCEPTS,
   SAVE_CATEGORY,
   GET_ITEM_CATEGORY,
   DELETE_CONCEPT_CATEGORY,
   DELETE_CATEGORY,
   CATEGORY_DEFAULT_DATA
} from '../constants/categories';

export const categories = ( state = {}, action ) => {
   switch ( action.type ) { 

      case GET_CATEGORIES : {
         return action.payload;
      }

      case CHANGE_VALUES_FORM : {
         return action.payload;
      }

      case SELECTED_ITEMS_CONCEPTS : {
         return action.payload;
      }

      case SAVE_CATEGORY : {
         return action.payload;
      }

      case GET_ITEM_CATEGORY : {
         return action.payload;
      }

      case DELETE_CONCEPT_CATEGORY : {
         return action.payload;
      }

      case DELETE_CATEGORY : {
         return action.payload;
      }

      case CATEGORY_DEFAULT_DATA : {
         return action.payload;
      }
 
     default :
     return state;
   }
}